import * as XLSX from 'xlsx';
 
export const ProductExport = (productList: any[]) => {
    const productData = transformProductData(productList);

    const sheetData = [
        ['Category', 'Sub Category', 'Measurement Type', 'HSN Code', 'Name', 'Unit Price', 'GST %', 'In Stock'],
        ...productData.map((item: any) => [
            item.Category,
            item.SubCategory,
            item.MeasurementType,
            item.HSNCode,
            item.Name,
            Number(item.UnitPrice ?? 0),
            item.GSTPercentage,
            item.InStock,
        ]),
    ];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Optional bold header formatting
    ['A1','B1','C1','D1','E1','F1','G1','H1'].forEach((headerCell) => {
        if (ws[headerCell]) {
            ws[headerCell].s = { font: { bold: true } };
        }
    });

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ProductListExport.xlsx');
};
 
const transformProductData = (productList: any[]) => {
    const flatData: any = [];
 
    productList?.forEach((product) => {
        flatData.push({
            'Category': product.categoryName,
            'SubCategory': product.subCategoryName,
            'MeasurementType': product.measurementTypeName,
            'HSNCode': product.hsN_Code || product.HSNCode || product.hsnCode || '',
            'Name': product.name,
            'UnitPrice': product.unitPrice,
            'GSTPercentage': product.gst,
            'InStock': product.inStock,
        });
    });
 
    return flatData;
};
 
 